// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthManagerDashboard\OperationsForecastResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { OperationsForecastPort as _OperationsForecastPort, OperationsForecastPortData as _OperationsForecastPortData, OperationsForecastPortDay as _OperationsForecastPortDay, OperationsForecastPortDayData as _OperationsForecastPortDayData, OperationsForecastPortDayOptions as _OperationsForecastPortDayOptions, OperationsForecastPortOptions as _OperationsForecastPortOptions } from 'data/models/OperationsForecast';
import { Port, PortData, PortOptions } from 'data/models/Port';

// OperationsForecastResponseData is the class that OperationsForecastResponse serializes to/from
export interface OperationsForecastResponseData {
    Date : /* ISO8601 */ string;
    OrganizationId : number;
	
    Ports : _OperationsForecastPortData[] | null;
	
}

// OperationsForecastResponseOptions is the class which may be passed to the OperationsForecastResponse constructor to define optional initial data values
export interface OperationsForecastResponseOptions {
    Date : /* ISO8601 */ string;
    OrganizationId : number;
	
    Ports? : _OperationsForecastPortOptions[] | null;
	
}

export class OperationsForecastResponse {
    public Date : DataSignal<TZDate>;
    public OrganizationId : DataSignal<number>;
	
    public Ports : SDataArray<_OperationsForecastPort>;
	

    constructor();
    constructor(data : OperationsForecastResponseOptions);
    constructor(data: OperationsForecastResponseOptions | null = null) {
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.Ports = SArray<_OperationsForecastPort>([]);
	    
    }

    static key(obj : OperationsForecastResponse) {
        return obj.Date().toJSON() + '\u2618' + obj.OrganizationId();
    }
    
    static dataKey(obj : OperationsForecastResponseOptions) {
        return new TZDate(obj.Date).toJSON() + '\u2618' + obj.OrganizationId;
    }

    static update(obj : OperationsForecastResponse, data : OperationsForecastResponseOptions) {
        S.freeze(() => {
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
	        
        });
    }
}

// OperationsForecastPortData is the class that OperationsForecastPort serializes to/from
export interface OperationsForecastPortData {
    OrganizationId : number;
    PortId : number;
	
    Days : _OperationsForecastPortDayData[] | null;
    Port : PortData | null;
	
}

// OperationsForecastPortOptions is the class which may be passed to the OperationsForecastPort constructor to define optional initial data values
export interface OperationsForecastPortOptions {
    OrganizationId : number;
    PortId : number;
	
    Days? : _OperationsForecastPortDayOptions[] | null;
    Port? : PortOptions | null;
	
}

export class OperationsForecastPort {
    public OrganizationId : DataSignal<number>;
    public PortId : DataSignal<number>;
	
    public Days : SDataArray<_OperationsForecastPortDay>;
    public Port : DataSignal<Port | null>;
	

    constructor();
    constructor(data : OperationsForecastPortOptions);
    constructor(data: OperationsForecastPortOptions | null = null) {
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
	    
        this.Days = SArray<_OperationsForecastPortDay>([]);
        this.Port = S.value<Port | null>(null);
	    
    }

    static key(obj : OperationsForecastPort) {
        return obj.OrganizationId() + '\u2618' + obj.PortId();
    }
    
    static dataKey(obj : OperationsForecastPortOptions) {
        return obj.OrganizationId + '\u2618' + obj.PortId;
    }

    static update(obj : OperationsForecastPort, data : OperationsForecastPortOptions) {
        S.freeze(() => {
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
	        
        });
    }
}

// OperationsForecastPortDayData is the class that OperationsForecastPortDay serializes to/from
export interface OperationsForecastPortDayData {
    Day : /* ISO8601 */ string;
    OrganizationId : number;
    PortId : number;
	
	
    Arrivals : number;
    Departures : number;
    ScheduledVessels : number;
    Services : number;
    Shifts : number;
}

// OperationsForecastPortDayOptions is the class which may be passed to the OperationsForecastPortDay constructor to define optional initial data values
export interface OperationsForecastPortDayOptions {
    Day : /* ISO8601 */ string;
    OrganizationId : number;
    PortId : number;
	
	
    Arrivals? : number;
    Departures? : number;
    ScheduledVessels? : number;
    Services? : number;
    Shifts? : number;
}

export class OperationsForecastPortDay {
    public Day : DataSignal<TZDate>;
    public OrganizationId : DataSignal<number>;
    public PortId : DataSignal<number>;
	
	
    public Arrivals : DataSignal<number>;
    public Departures : DataSignal<number>;
    public ScheduledVessels : DataSignal<number>;
    public Services : DataSignal<number>;
    public Shifts : DataSignal<number>;

    constructor();
    constructor(data : OperationsForecastPortDayOptions);
    constructor(data: OperationsForecastPortDayOptions | null = null) {
        this.Day = jsonableObservable(S.value<TZDate>(data && data.Day !== undefined ? new TZDate(data.Day) : new TZDate(0), TZDate.eq));
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
	    
	    
        this.Arrivals = jsonableObservable(S.value<number>(data && data.Arrivals !== undefined ? data.Arrivals : 0));
        this.Departures = jsonableObservable(S.value<number>(data && data.Departures !== undefined ? data.Departures : 0));
        this.ScheduledVessels = jsonableObservable(S.value<number>(data && data.ScheduledVessels !== undefined ? data.ScheduledVessels : 0));
        this.Services = jsonableObservable(S.value<number>(data && data.Services !== undefined ? data.Services : 0));
        this.Shifts = jsonableObservable(S.value<number>(data && data.Shifts !== undefined ? data.Shifts : 0));
    }

    static key(obj : OperationsForecastPortDay) {
        return obj.Day().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.PortId();
    }
    
    static dataKey(obj : OperationsForecastPortDayOptions) {
        return new TZDate(obj.Day).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + obj.PortId;
    }

    static update(obj : OperationsForecastPortDay, data : OperationsForecastPortDayOptions) {
        S.freeze(() => {
            if (data.Day !== undefined) obj.Day(new TZDate(data.Day));
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
	        
            if (data.Arrivals !== undefined) obj.Arrivals(data.Arrivals);
            if (data.Departures !== undefined) obj.Departures(data.Departures);
            if (data.ScheduledVessels !== undefined) obj.ScheduledVessels(data.ScheduledVessels);
            if (data.Services !== undefined) obj.Services(data.Services);
            if (data.Shifts !== undefined) obj.Shifts(data.Shifts);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/OperationsForecast.ts